// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3[data-v-a9c86e10] {\n  margin: 40px 0 0;\n}\nul[data-v-a9c86e10] {\n  list-style-type: none;\n  padding: 0;\n}\nli[data-v-a9c86e10] {\n  display: inline-block;\n  margin: 0 10px;\n}\na[data-v-a9c86e10] {\n  color: #42b983;\n}\n.map[data-v-a9c86e10] {\n  padding: 0px;\n  margin: 0px;\n  width: 100%;\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
